import MobileHeader from "./MobileHeader";

const steps = ["Stay", "Guests", "Review", "Payment"];

export default function MobileBookingProgress({ active = 0, crumb = "" }) {
  const activeIndex = Math.max(0, Math.min(steps.length - 1, Number(active) || 0));

  return (
    <>
      <MobileHeader showBack />
      <nav className="hv-ref-rail hv-booking-progress-rail" aria-label="Booking progress">
        <div className="hv-ref-track" />
        {steps.map((step, index) => (
          <div
            className={`hv-ref-step ${index < activeIndex ? "complete" : ""} ${index === activeIndex ? "active" : ""}`}
            key={step}
            aria-current={index === activeIndex ? "step" : undefined}
          >
            <span>{index < activeIndex ? <i className="bi bi-check" aria-hidden="true" /> : index + 1}</span>
            <b>{step}</b>
          </div>
        ))}
      </nav>
      {crumb ? <div className="hv-booking-progress-crumb">{crumb}</div> : null}
    </>
  );
}
